module.exports = __webpack_public_path__ + "img/launch.3b48d904.svg";